import { Navigate } from 'react-router-dom';

const DEV = process.env.REACT_APP_DEV_MODE === 'true';

export default function ProtectedRoute({ children }) {
  if (DEV) return children;
  const token = localStorage.getItem('bce_token');
  if (!token) return <Navigate to="/" replace />;
  return children;
}
